import Link from 'next/link'
import React from 'react'

interface ISidebarItem {
	label: string
	href: string
	target?: string
}

interface IProps {
	sidebarItems: ISidebarItem[]
}

const ZAmbulanceContentSidebar = ({ sidebarItems }: IProps) => {
	if (!sidebarItems.length) {
		return null
	}

	const getTarget = (sidebarItem: ISidebarItem) => {
		if (sidebarItem.target) {
			return sidebarItem.target
		}

		return sidebarItem.href.split('#')[1] || ''
	}

	return (
		<div className='pos_abs h100p pdt-70lg pdt-100'>
			<ul id='sections-menu' className='sticky-menu hide_xlm'>
				{sidebarItems.map(item => (
					<li key={item.href}>
						<Link href={item.href} data-target={getTarget(item)} prefetch={false}>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</div>
	)
}

export default ZAmbulanceContentSidebar
